import React from "react";
import styles from "./ErrorPage.module.css";
import error2 from "../../images/error2.png"; // Іконка помилки

const ErrorPage = () => {
    return (
        <div className={styles.errorPage}>
            <div className={styles.container}>
                <h1 className={styles.title}>Ojej, coś poszło nie tak.</h1>
                <img src={error2} alt="Error Icon" className={styles.icon} />
                <p className={styles.subtitle}>Spróbuj ponownie!</p>
            </div>
        </div>
    );
};

export default ErrorPage;
